module.exports = __webpack_public_path__ + "static/img/banner02.799a42f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CorporateTravel/banner02.png
// module id = VaB1
// module chunks = 1